import * as constants from './constants';
import KAjax from './KAjax';
import * as service from './service';
import * as commonConst from "./constants";

export default {

    [constants.unifiedAjax](ctx, data) {
        return new Promise((resolve, reject) => {
            KAjax.ajax(data.path, data.method, data.params, data.data, data.option).done((res) => {
                resolve(res);
            }).fail((e) => {
                reject(e);
            });
        });
    },
    [constants.CalcEipPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.CalcEipPrice);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [constants.getEbsSnap](ctx, params) {
        params = _.merge(params, service.getEbsSnap);
        return new Promise((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then(res => {
                if(res.msg) {
                    reject(res.msg)
                } else {
                    ctx.commit(constants.getEbsSnap, res);
                    resolve(res);
                }
            }).catch(e => {
                reject(e);
            });
        });
    },

    [constants.regionList](ctx) {
        return new Promise((resolve, reject) => {
            ctx.dispatch(constants.unifiedAjax, service.RegionList).then(req => {
                let regionList = req.value;
                regionList = _.map(regionList, (item) => {
                    item.isVpc = item.region_code == 'cn-beijing-5' ? 0 : +item.isVpc;
                    return item;
                });
                var basicRegion = _.filter(regionList, (item) => {
                    return !item.isVpc;
                });
                var vpcRegion = _.filter(regionList, (item) => {
                    return item.isVpc;
                });
                var regionOrder = ['cn-beijing-6', 'cn-shanghai-2', 'cn-hongkong-2', 'cn-beijing-1-new', 'ap-singapore-1'];
                vpcRegion = _.sortBy(vpcRegion, function(item) {
                    return _.indexOf(regionOrder, item.region_code.toLowerCase());
                });
                ctx.commit(constants.regionList, vpcRegion.concat(basicRegion));
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [constants.RegionInfos](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.RegionInfos);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                ctx.commit(constants.RegionInfos, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [constants.QueryProductGroups](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.QueryProductGroups);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                ctx.commit(constants.QueryProductGroups, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [constants.Getlines](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.Getlines);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                ctx.commit(constants.Getlines, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [constants.DescribeBandWidthShares](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeBandWidthShares);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                ctx.commit(constants.DescribeBandWidthShares, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.OSImageList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.OSImageList);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.OSImageList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [constants.ImageList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.ImageList);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.ImageList, data);
                resolve(data);
            }).catch(e => {
                ctx.commit(constants.ImageList, {ImagesSet: []});
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [constants.DedicatedList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.DedicatedList);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.DedicatedList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [constants.projList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.projList);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.projList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [constants.getDedicatedCluster](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.getDedicatedCluster);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.getDedicatedCluster, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [constants.snapList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.snapList);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.snapList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [constants.snapLessNum](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.snapLessNum);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                ctx.commit(constants.snapLessNum, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [constants.CalculateKeadProduct](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.CalculateKeadProduct);
            ctx.dispatch(constants.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //--以下为未登录actions--
    [constants.noLoginGetlines](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.noLoginGetlines);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                ctx.commit(constants.noLoginGetlines, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.noLoginQueryProductGroups](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.noLoginQueryProductGroups);
            ctx.dispatch(constants.unifiedAjax, params).then(req => {
                ctx.commit(constants.noLoginQueryProductGroups, req);
                resolve(req);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //--以上为未登录actions--
}
